import React, { PureComponent } from "react";
import { connect } from "react-redux";

import styles from "./Dashboard.local.scss";
import _ from "i18n";
import EmbeddedDashboard from "./EmbeddedDashboard";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { getEmbedWidthParam } from "Utils";
import { selectRouting } from "../../selectors";
import FetchingEmbeddedContent from "./FetchingEmbeddedContent";

class EmbeddedPage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen, id } = this.props.uen ? this.props : this.props.match.params;

    this.state = { organizationUen: uen, dashboardId: id };
  }
  /*
  componentDidMount() {
    const { dispatch } = this.props;
    const { organizationUen, dashboardId } = this.state;
     dispatch(fetchDashboard(null, organizationUen, dashboardId));
  }*/

  handleError = () => {
    const { error } = this.props;

    if (error.code === 170043) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"noBalanceImportedMessage"}
          buttonIgnored={1}
        />
      );
    } else if (error.code === 170060) {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={`${_("accessDenied")} : ${_("dashboardNotFound")}`}
          buttonIgnored={1}
        />
      );
    } else {
      return (
        <NotFoundV2
          errorPageType={"ACCESS_DENIED"}
          text={"errorOccured"}
          buttonIgnored={1}
        />
      );
    }
  };

  render() {
    const {
      embeddedStyle,
      dashboardData,
      organization,
      currentOrganization,
      fetching,
      fetched,
      error,
      routing
    } = this.props;

    const embedWidth = getEmbedWidthParam(routing.location) || "100%";

    return (
      <div className={`page-content`}>
        <div
          style={{
            width: embedWidth
          }}
        >
          {fetching &&
            !embeddedStyle && (
              <div className={styles.ripple_loading}>
                <img src={"/img/Ripple-1s-150px.svg"} alt="" />
              </div>
            )}
          {fetching && embeddedStyle && <FetchingEmbeddedContent />}

          {/* @todo gérer les cas de not found*/}
          {/* @todo custom handle error component for embedded dashboards */}
          {error && !fetching && this.handleError()}

          {fetched &&
            embeddedStyle &&
            dashboardData && (
              <EmbeddedDashboard
                data={dashboardData}
                embeddedStyle={embeddedStyle}
                organization={organization}
                currentOrganization={currentOrganization}
              />
            )}
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.dashboard.fetching,
  fetched: state.dashboard.fetched,
  error: state.dashboard.error,
  dashboardData: state.dashboard.data,
  organization: state.dashboard.organization,
  currentOrganization: state.auth.currentOrganization,
  routing: selectRouting(state)
});

export default connect(mapStateToProps)(EmbeddedPage);



// WEBPACK FOOTER //
// ./src/components/Dashboard/EmbeddedPage.js